var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHrws(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 895,
    height: 213,
    viewBox: "0 0 895 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M476.33 79.0985C471.25 64.6285 466.16 50.1285 461.07 35.6285C460.91 35.6485 460.75 35.6685 460.59 35.6785C455.55 50.1385 450.52 64.5885 445.47 79.0885H426.83C418.31 53.4185 409.77 27.6885 401.14 1.69851H423.75C428.09 16.1285 432.47 30.6885 436.85 45.2485C437 45.2485 437.16 45.2485 437.31 45.2385C442.16 30.6585 447 16.0785 451.86 1.47852H470.34C475.2 16.1285 480.04 30.7185 484.87 45.3185C485.02 45.2985 485.16 45.2785 485.31 45.2585C489.69 30.7385 494.07 16.2285 498.46 1.66851H520.66C512.05 27.6185 503.5 53.3585 494.95 79.1085H476.32L476.33 79.0985Z",
    fill: "#090909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M581.08 133.538C582.04 133.538 582.75 133.538 583.46 133.538C589.46 133.538 595.46 133.598 601.45 133.498C603.02 133.468 603.88 133.978 604.69 135.318C609.87 143.868 615.14 152.348 620.39 160.858C620.8 161.528 621.25 162.178 621.91 163.198C628.12 153.268 634.05 143.478 640.15 133.668H662.74V210.198C661.03 210.738 644.46 210.848 641.54 210.308V167.558C641.38 167.498 641.22 167.448 641.06 167.388C639.27 169.658 637.85 172.188 636.23 174.588C634.62 176.978 633.08 179.408 631.51 181.818C629.89 184.298 628.28 186.778 626.66 189.248C625.1 191.638 623.52 194.028 621.72 196.778C619.3 193.418 617.32 190.178 615.23 187.028C613.06 183.768 610.94 180.478 608.79 177.198C606.71 174.018 604.62 170.848 602.25 167.748C601.93 171.358 601.96 174.898 601.95 178.448C601.95 181.968 601.95 185.488 601.95 189.008V210.468H581.1V133.538H581.08Z",
    fill: "#090909"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M725.07 163.208C731.27 153.158 737.26 143.438 743.3 133.658H765.53C766.09 135.378 766.26 207.388 765.7 210.468H744.75V167.368C743.51 167.738 743.26 168.648 742.82 169.308C737.34 177.668 731.89 186.038 726.43 194.408C725.97 195.118 725.46 195.808 724.76 196.798C718.26 186.888 711.97 177.298 705.68 167.698C705.51 167.718 705.35 167.738 705.18 167.758C705.13 168.558 705.04 169.358 705.04 170.158C705.04 182.638 705.04 195.108 705.04 207.588C705.04 208.518 705.04 209.448 705.04 210.498H684.27V133.738C684.86 133.678 685.47 133.548 686.08 133.548C692.32 133.538 698.56 133.588 704.79 133.508C706.29 133.488 707.07 134.068 707.8 135.278C713 143.808 718.26 152.308 723.51 160.818C723.92 161.488 724.37 162.138 725.07 163.218V163.208Z",
    fill: "#090909"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M853.15 31.2584C859.42 21.0984 865.44 11.3283 871.43 1.62835H893.61C894.14 3.36835 894.31 75.2583 893.79 78.4783H872.83V35.0484C870.79 37.0584 869.82 39.1283 868.55 40.9683C867.24 42.8783 866 44.8483 864.74 46.7883C863.43 48.7983 862.12 50.8083 860.81 52.8183C859.54 54.7583 858.28 56.7083 857.01 58.6483C855.75 60.5783 854.48 62.4983 853 64.7483C851 62.2283 849.55 59.6983 847.93 57.2883C846.33 54.8983 844.77 52.4783 843.19 50.0683C841.57 47.5983 839.95 45.1183 838.33 42.6483C836.77 40.2683 835.2 37.8884 833.63 35.5084C833.46 35.5484 833.29 35.5883 833.12 35.6383V78.5083H812.38V1.62835C813.14 1.58835 813.76 1.53835 814.38 1.53835C820.54 1.53835 826.7 1.57835 832.86 1.49835C834.33 1.47835 835.15 2.00835 835.89 3.23835C840.95 11.5783 846.09 19.8684 851.21 28.1684C851.75 29.0484 852.31 29.9183 853.14 31.2483L853.15 31.2584Z",
    fill: "#090909"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M636.85 78.4883V1.65834C637.75 1.60834 638.53 1.53834 639.31 1.53834C648.67 1.53834 658.03 1.47834 667.38 1.54834C675.47 1.60834 683.31 3.02834 690.55 6.80834C702.04 12.7983 708.15 22.4783 709.61 35.1983C710.5 42.9983 709.41 50.5183 705.86 57.5783C700.92 67.4083 692.75 73.2383 682.42 76.3583C677.25 77.9183 671.93 78.5483 666.56 78.5983C657.28 78.6883 648 78.6283 638.73 78.6183C638.18 78.6183 637.64 78.5383 636.86 78.4783L636.85 78.4883ZM658.26 59.9483C662.83 59.7883 667.17 59.9583 671.42 59.4283C680.65 58.2783 686.61 52.3783 687.76 43.2783C689.56 29.0983 680.71 21.5983 670.61 20.6283C667.04 20.2883 663.43 20.3783 659.84 20.3083C659.32 20.2983 658.79 20.4583 658.25 20.5383V59.9483H658.26Z",
    fill: "#090909"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M801.02 38.6085C801 59.1585 787.6 75.5185 768.75 79.1985C754.66 81.9485 741.8 79.1485 730.96 69.4485C712.46 52.8785 714.37 22.3885 734.66 7.91845C749.27 -2.49155 769.8 -2.70155 784.44 7.66845C795.56 15.5485 800.66 26.6585 801.02 38.6085ZM779.32 40.7085C779.36 33.5985 776.97 28.1285 772.08 23.8085C765.28 17.8085 754.21 17.7885 747.37 23.5985C737.75 31.7685 737.5 48.4185 747.82 56.7785C755.27 62.8085 766.7 62.1985 773.37 55.3285C777.48 51.0985 779.35 45.9785 779.31 40.7085H779.32Z",
    fill: "#090909"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M488.99 133.668H510.54C510.54 134.728 510.54 135.658 510.54 136.588C510.54 149.388 510.51 162.178 510.57 174.978C510.57 177.288 510.7 179.638 511.17 181.888C512.67 189.088 517.73 193.038 525.08 192.718C527.2 192.628 529.42 192.238 531.36 191.418C536.12 189.408 538.1 185.298 538.69 180.418C538.85 179.078 538.85 177.708 538.85 176.348C538.86 163.148 538.85 149.958 538.85 136.758V133.978C540.8 133.438 557.75 133.358 560.43 133.848C560.47 134.658 560.53 135.508 560.54 136.368C560.54 149.878 560.56 163.398 560.54 176.908C560.54 181.078 560.08 185.198 559.02 189.248C556.17 200.098 549.25 207.048 538.59 210.138C529.58 212.758 520.42 212.818 511.35 210.348C499.18 207.028 492.03 198.958 489.82 186.598C489.24 183.388 488.95 180.088 488.92 176.828C488.82 163.078 488.88 149.318 488.88 135.568C488.88 135.018 488.94 134.468 488.99 133.668Z",
    fill: "#090909"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M624.39 10.5183C620.77 15.6283 617.28 20.5483 613.75 25.5283C611.85 24.4083 610.17 23.3483 608.42 22.4083C603.79 19.9083 598.88 18.2783 593.59 18.1383C591.85 18.0883 590.06 18.2083 588.37 18.6083C585.97 19.1883 584.55 20.9083 584.49 22.9383C584.43 25.2183 585.65 26.8183 587.7 27.5183C591.24 28.7283 594.87 29.6983 598.46 30.7583C602.29 31.8783 606.17 32.8483 609.94 34.1383C612.19 34.9083 614.34 36.0483 616.42 37.2083C624.45 41.6883 627.21 48.8183 626.35 57.6183C625.48 66.5483 620.62 72.6583 612.67 76.4683C607.68 78.8583 602.35 79.7383 596.85 79.8483C585.05 80.0883 574.01 77.5483 564.07 70.9483C562.87 70.1583 561.76 69.2383 560.62 68.3583C560.19 68.0183 559.8 67.6183 559.2 67.0683C563.14 62.3783 567.02 57.7583 571.06 52.9483C571.83 53.4883 572.52 53.9783 573.21 54.4683C580.61 59.7383 588.75 62.6083 597.92 61.9883C599.39 61.8883 600.96 61.4983 602.26 60.8183C605.55 59.0883 605.74 55.0283 602.62 53.0183C601.17 52.0783 599.48 51.4183 597.81 50.9383C593.59 49.7283 589.28 48.8183 585.07 47.5683C581.78 46.5983 578.48 45.5483 575.38 44.1183C564.6 39.1683 561.06 30.4183 563.47 19.2483C565.45 10.0883 571.86 4.82834 580.45 1.98834C586.41 0.0183411 592.57 0.0183407 598.74 0.558341C607.51 1.32834 615.61 4.02834 622.78 9.25834C623.23 9.58834 623.65 9.94834 624.37 10.5083L624.39 10.5183Z",
    fill: "#090909"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M404.66 199.068C408.66 194.318 412.56 189.688 416.55 184.948C417.44 185.588 418.21 186.148 418.99 186.698C426.29 191.808 434.3 194.588 443.29 194.008C444.77 193.908 446.34 193.548 447.64 192.878C451.06 191.128 451.23 186.998 447.98 184.948C446.58 184.068 444.98 183.418 443.38 182.968C439.08 181.748 434.7 180.808 430.41 179.548C427.28 178.628 424.17 177.538 421.16 176.278C403.43 168.888 405.85 147.148 416.56 138.938C421.15 135.418 426.25 133.298 431.9 132.688C442.69 131.518 453.14 132.798 462.87 137.928C465.25 139.178 467.45 140.768 469.96 142.338C466.26 147.558 462.77 152.488 459.19 157.538C458.34 157.018 457.6 156.568 456.87 156.118C451.36 152.678 445.47 150.308 438.9 150.118C437.17 150.068 435.38 150.258 433.7 150.658C431.6 151.158 430.15 152.568 429.97 154.838C429.79 157.118 431.02 158.768 433.06 159.478C436.68 160.718 440.39 161.688 444.05 162.788C448.4 164.098 452.81 165.258 457.08 166.818C459.45 167.678 461.68 169.058 463.8 170.468C470.71 175.098 472.57 181.948 471.79 189.758C470.88 198.908 465.73 204.978 457.58 208.738C454.14 210.328 450.48 211.248 446.73 211.578C434.84 212.638 423.46 210.848 412.89 205.018C409.95 203.398 407.2 201.508 404.67 199.058L404.66 199.068Z",
    fill: "#090909"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M826.75 133.678H893.69C894.25 135.378 894.41 148.868 893.87 152.278H871.02V210.458H849.7C849.66 191.198 849.7 171.958 849.67 152.428C842.02 152.108 834.46 152.448 826.75 152.228V133.678Z",
    fill: "#090909"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M529.72 1.64844H550.69V78.4784H529.72V1.64844Z",
    fill: "#090909"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M808.89 133.719V210.258C807.12 210.728 791.41 210.859 788.11 210.449C787.61 208.779 787.39 137.769 787.9 133.729H808.89V133.719Z",
    fill: "#090909"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 211.349V2.27856L40.73 92.2186L0 211.349Z",
    fill: "#E8B500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.27856H68.73L40.73 92.2186L0 2.27856Z",
    fill: "#FFD94A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.73 2.27856V79.3186L40.73 92.2186L68.73 2.27856Z",
    fill: "#E8B500"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 211.349H68.73L40.73 92.2185L0 211.349Z",
    fill: "#B77A00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.73 211.349V133.459L40.73 92.2185L68.73 211.349Z",
    fill: "#FFD94A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.73 133.459H144.81L40.73 92.2185L68.73 133.459Z",
    fill: "#B77A00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.73 79.3186H134.29L132.93 101.609L93.23 113.019L40.73 92.2186L68.73 79.3186Z",
    fill: "#FFD94A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M144.81 133.459L132.93 101.609L93.23 113.019L144.81 133.459Z",
    fill: "#E8B500"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132.93 101.609L154.18 97.8986L134.29 79.3186L132.93 101.609Z",
    fill: "#E8B500"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M144.81 133.459L154.18 97.8987L132.93 101.609L144.81 133.459Z",
    fill: "#B77A00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M134.29 79.3186V3.07861L154.18 97.8986L134.29 79.3186Z",
    fill: "#E8B500"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M134.29 3.07861H195.04L154.18 97.8986L134.29 3.07861Z",
    fill: "#FFD94A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M134.29 133.458H144.81L134.29 211.348V133.458Z",
    fill: "#E8B500"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M134.29 211.349H195.04L154.18 97.8987L144.81 133.459L134.29 211.349Z",
    fill: "#FFD94A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M195.04 3.07861V211.349L154.18 97.8986L195.04 3.07861Z",
    fill: "#E8B500"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M195.04 3.07861H317.51L259.3 39.9486L195.04 3.07861Z",
    fill: "#FFD94A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M195.04 3.07861V98.8386L234.02 50.4886L195.04 3.07861Z",
    fill: "#FFD94A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M234.02 50.4886L259.3 39.9486L195.04 3.07861L234.02 50.4886Z",
    fill: "#E8B500"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M234.02 50.4886L259.3 39.9486L195.04 3.07861L234.02 50.4886Z",
    fill: "url(#paint0_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M244.37 55.5585L259.3 39.9485L234.02 50.4885L244.37 55.5585Z",
    fill: "#FFD94A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M244.37 55.5585H283.74L259.3 39.9485L244.37 55.5585Z",
    fill: "#B77A00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M283.74 55.5585H301.84L259.3 39.9485L283.74 55.5585Z",
    fill: "#FFD94A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M317.51 3.07861L301.84 55.5586L259.3 39.9486L317.51 3.07861Z",
    fill: "#E8B500"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M301.75 55.5586H363.92L317.51 3.07861L301.75 55.5586Z",
    fill: "#FFD94A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M363.92 55.5586V101.159L326.28 108.279L363.92 55.5586Z",
    fill: "#FFD94A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M326.28 108.279L301.75 55.5586H363.92L326.28 108.279Z",
    fill: "#E8B500"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M301.75 72.9886V55.5586H283.74L301.75 72.9886Z",
    fill: "#E8B500"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M326.28 108.279L301.75 90.6886V55.5586L326.28 108.279Z",
    fill: "#B77A00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M326.28 108.278H285.1L301.75 90.6885L326.28 108.278Z",
    fill: "#E8B500"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M307.95 126.839L326.28 108.279H285.1L307.95 126.839Z",
    fill: "#FFD94A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M363.92 101.159L307.95 126.839L326.28 108.279L363.92 101.159Z",
    fill: "#B77A00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M328.31 144.709L363.92 101.159L307.95 126.839L328.31 144.709Z",
    fill: "#E8B500"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M285.1 108.279H244.37L307.95 126.839L285.1 108.279Z",
    fill: "#B77A00"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M307.95 126.839L287.59 173.339L328.31 144.709L307.95 126.839Z",
    fill: "#FFD94A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M195.04 211.349L244.37 141.549V211.349H195.04Z",
    fill: "#FFD94A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M301.73 211.349H383.86L287.59 173.339L301.73 211.349Z",
    fill: "#E8B500"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M330.46 148.448L328.31 144.708L287.59 173.338L330.46 148.448Z",
    fill: "#E8B500"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M383.86 211.348L330.46 148.448L287.59 173.338L383.86 211.348Z",
    fill: "#FFD94A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M301.73 211.349L244.37 141.549L287.59 173.339L301.73 211.349Z",
    fill: "#B77A00"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M244.37 108.279L263.04 135.209L244.37 141.549V108.279Z",
    fill: "#FFD94A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M307.95 126.839L263.04 135.209L244.37 108.279L307.95 126.839Z",
    fill: "#E8B500"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M287.59 173.339L307.95 126.839L263.04 135.209L244.37 141.549L287.59 173.339Z",
    fill: "#FFD94A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M234.02 50.4885L244.37 67.5585V55.5585L234.02 50.4885Z",
    fill: "#B77A00"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M244.37 108.279V67.5585L234.02 50.4885L195.04 98.8385V211.349L244.37 141.549V108.279Z",
    fill: "#E8B500"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M234.02 50.4886L259.3 39.9486L195.04 3.07861L234.02 50.4886Z",
    fill: "url(#paint1_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M307.95 126.839L326.28 108.279H285.1L307.95 126.839Z",
    fill: "url(#paint2_linear_82_132)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 211.349V2.27856L40.73 92.2186L0 211.349Z",
    fill: "#E8B500"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M195.05 3.07861V98.8386L234.02 50.4886L195.05 3.07861Z",
    fill: "url(#paint3_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M234.02 50.4886L259.3 39.9486L195.04 3.07861L234.02 50.4886Z",
    fill: "url(#paint4_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M195.04 211.349L244.37 141.549V211.349H195.04Z",
    fill: "url(#paint5_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M244.37 55.5585L259.3 39.9485L234.02 50.4885L244.37 55.5585Z",
    fill: "url(#paint6_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M244.37 55.5585H283.74L259.3 39.9485L244.37 55.5585Z",
    fill: "url(#paint7_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M283.74 55.5585H301.84L259.3 39.9485L283.74 55.5585Z",
    fill: "url(#paint8_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M317.51 3.07861L301.84 55.5586L259.3 39.9486L317.51 3.07861Z",
    fill: "url(#paint9_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M301.75 55.5586H363.92L317.51 3.07861L301.75 55.5586Z",
    fill: "url(#paint10_linear_82_132)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M363.92 55.5586V101.159L326.28 108.279L363.92 55.5586Z",
    fill: "url(#paint11_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M326.28 108.279L301.75 55.5586H363.92L326.28 108.279Z",
    fill: "url(#paint12_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M301.75 72.9886V55.5586H283.74L301.75 72.9886Z",
    fill: "url(#paint13_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M326.28 108.279L301.75 90.6886V55.5586L326.28 108.279Z",
    fill: "url(#paint14_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M326.28 108.278H285.1L301.75 90.6885L326.28 108.278Z",
    fill: "url(#paint15_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M363.92 101.159L307.95 126.839L326.28 108.279L363.92 101.159Z",
    fill: "url(#paint16_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M328.31 144.709L363.92 101.159L307.95 126.839L328.31 144.709Z",
    fill: "url(#paint17_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M285.1 108.279H244.37L307.95 126.839L285.1 108.279Z",
    fill: "url(#paint18_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M307.95 126.839L287.59 173.339L328.31 144.709L307.95 126.839Z",
    fill: "url(#paint19_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M301.73 211.349H383.86L287.59 173.339L301.73 211.349Z",
    fill: "url(#paint20_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M330.46 148.448L328.31 144.708L287.59 173.338L330.46 148.448Z",
    fill: "url(#paint21_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M383.86 211.348L330.46 148.448L287.59 173.338L383.86 211.348Z",
    fill: "url(#paint22_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M301.73 211.349L244.37 141.549L287.59 173.339L301.73 211.349Z",
    fill: "url(#paint23_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M244.37 108.279L263.04 135.209L244.37 141.549V108.279Z",
    fill: "url(#paint24_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M307.95 126.839L263.04 135.209L244.37 108.279L307.95 126.839Z",
    fill: "url(#paint25_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M287.59 173.339L307.95 126.839L263.04 135.209L244.37 141.549L287.59 173.339Z",
    fill: "url(#paint26_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M234.02 50.4885L244.37 67.5585V55.5585L234.02 50.4885Z",
    fill: "url(#paint27_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M244.37 108.279V67.5585L234.02 50.4885L195.04 98.8385V211.349L244.37 141.549V108.279Z",
    fill: "url(#paint28_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M195.04 3.07861H317.51L259.3 39.9486L195.04 3.07861Z",
    fill: "url(#paint29_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0 211.319V2.27856L40.73 92.2186L0 211.319Z",
    fill: "url(#paint30_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M0 2.27856H68.73L40.73 92.2186L0 2.27856Z",
    fill: "url(#paint31_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.73 2.27856V79.3186L40.73 92.2186L68.73 2.27856Z",
    fill: "url(#paint32_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M0 211.319H68.73L40.73 92.2185L0 211.319Z",
    fill: "url(#paint33_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.73 211.319V133.459L40.73 92.2185L68.73 211.319Z",
    fill: "url(#paint34_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.73 133.459H144.81L40.73 92.2185L68.73 133.459Z",
    fill: "url(#paint35_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.73 79.3186H134.29L132.93 101.609L93.23 113.019L40.73 92.2186L68.73 79.3186Z",
    fill: "url(#paint36_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M144.81 133.459L132.93 101.609L93.23 113.019L144.81 133.459Z",
    fill: "url(#paint37_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M132.93 101.609L154.18 97.8986L134.29 79.3186L132.93 101.609Z",
    fill: "url(#paint38_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M144.81 133.459L154.18 97.8987L132.93 101.609L144.81 133.459Z",
    fill: "url(#paint39_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M134.29 79.3186V3.07861L154.18 97.8986L134.29 79.3186Z",
    fill: "url(#paint40_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M134.29 3.07861H195.04L154.18 97.8986L134.29 3.07861Z",
    fill: "url(#paint41_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M134.29 133.458H144.81L134.29 211.348V133.458Z",
    fill: "url(#paint42_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M134.29 211.349H195.04L154.18 97.8987L144.81 133.459L134.29 211.349Z",
    fill: "url(#paint43_linear_82_132)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M195.04 3.07861V211.349L154.18 97.8986L195.04 3.07861Z",
    fill: "url(#paint44_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M235.78 3.07861H195.04V211.349H235.78V3.07861Z",
    fill: "url(#paint45_linear_82_132)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_132",
    x1: 259.3,
    y1: 26.7786,
    x2: 195.04,
    y2: 26.7786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_82_132",
    x1: 195.04,
    y1: 26.7786,
    x2: 259.3,
    y2: 26.7786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_82_132",
    x1: 321.76,
    y1: 114.009,
    x2: 290.42,
    y2: 118.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFFCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF6D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFEDAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFE06D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_82_132",
    x1: 233.55,
    y1: 54.9986,
    x2: 190.07,
    y2: 50.4286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFFBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEA9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFDB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_82_132",
    x1: 227.22,
    y1: 21.4286,
    x2: 216.34,
    y2: 40.2786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_82_132",
    x1: 223.37,
    y1: 178.499,
    x2: 236.1,
    y2: 185.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_82_132",
    x1: 234.02,
    y1: 47.7585,
    x2: 259.3,
    y2: 47.7585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_82_132",
    x1: 244.37,
    y1: 47.7585,
    x2: 283.74,
    y2: 47.7585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_82_132",
    x1: -36.8998,
    y1: 47.7585,
    x2: 301.84,
    y2: 47.7585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_82_132",
    x1: 282.56,
    y1: 15.8686,
    x2: 312.37,
    y2: 44.6586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_82_132",
    x1: 345.43,
    y1: 22.3486,
    x2: 313.63,
    y2: 69.4186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFF3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFE892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFDA52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_82_132",
    x1: 372.88,
    y1: 96.2086,
    x2: 341.77,
    y2: 80.2086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFFBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFF7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFF1BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFE99A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFE06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_82_132",
    x1: 301.75,
    y1: 81.9186,
    x2: 363.92,
    y2: 81.9186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_82_132",
    x1: 283.74,
    y1: 64.2786,
    x2: 301.75,
    y2: 64.2786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_82_132",
    x1: 301.75,
    y1: 81.9186,
    x2: 326.28,
    y2: 81.9186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_82_132",
    x1: 285.1,
    y1: 99.4885,
    x2: 326.28,
    y2: 99.4885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_82_132",
    x1: 307.95,
    y1: 113.999,
    x2: 363.92,
    y2: 113.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_82_132",
    x1: 307.95,
    y1: 122.939,
    x2: 363.92,
    y2: 122.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_82_132",
    x1: 244.37,
    y1: 117.559,
    x2: 307.95,
    y2: 117.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_82_132",
    x1: 310.66,
    y1: 133.709,
    x2: 307.1,
    y2: 166.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFFAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFEEB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFDA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_82_132",
    x1: 287.59,
    y1: 192.339,
    x2: 383.86,
    y2: 192.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_82_132",
    x1: 287.59,
    y1: 159.018,
    x2: 330.46,
    y2: 159.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_82_132",
    x1: 287.59,
    y1: 179.898,
    x2: 383.86,
    y2: 179.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFFBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEA9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFDB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_82_132",
    x1: 244.37,
    y1: 176.449,
    x2: 301.73,
    y2: 176.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_82_132",
    x1: 252.15,
    y1: 135.649,
    x2: 244.68,
    y2: 122.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFE894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_82_132",
    x1: 244.37,
    y1: 121.749,
    x2: 307.95,
    y2: 121.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_82_132",
    x1: 267.85,
    y1: 129.249,
    x2: 296.36,
    y2: 149.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFF1BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFE68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFDA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_82_132",
    x1: 234.02,
    y1: 59.0185,
    x2: 244.37,
    y2: 59.0185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_82_132",
    x1: 195.04,
    y1: 130.919,
    x2: 244.37,
    y2: 130.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_82_132",
    x1: 256.26,
    y1: 2.00861,
    x2: 256.92,
    y2: 39.9886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFFBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEA9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFDB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_82_132",
    x1: 0,
    y1: 106.799,
    x2: 40.73,
    y2: 106.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_82_132",
    x1: 34.82,
    y1: 13.8186,
    x2: 36.18,
    y2: 48.0986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFE791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDA52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_82_132",
    x1: 54.18,
    y1: 47.0686,
    x2: 76.82,
    y2: 54.4286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_82_132",
    x1: 29.19,
    y1: 221.939,
    x2: 72.23,
    y2: 103.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_82_132",
    x1: 73.16,
    y1: 141.129,
    x2: 39.45,
    y2: 160.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_82_132",
    x1: 68.51,
    y1: 133.199,
    x2: 113.16,
    y2: 95.7285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_82_132",
    x1: 84.85,
    y1: 106.899,
    x2: 94.01,
    y2: 60.7386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_82_132",
    x1: 144.81,
    y1: 117.529,
    x2: 93.23,
    y2: 117.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_82_132",
    x1: 144.7,
    y1: 88.0586,
    x2: 133.17,
    y2: 101.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_82_132",
    x1: 132.93,
    y1: 115.679,
    x2: 154.18,
    y2: 115.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_82_132",
    x1: 124.29,
    y1: 61.9986,
    x2: 157.31,
    y2: 42.9386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_82_132",
    x1: 164.89,
    y1: 8.66861,
    x2: 166.25,
    y2: 42.9486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFEEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_82_132",
    x1: 126.02,
    y1: 169.278,
    x2: 143.09,
    y2: 173.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_82_132",
    x1: 164.67,
    y1: 204.539,
    x2: 164.67,
    y2: 153.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFFAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FFEFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_82_132",
    x1: 195.04,
    y1: 107.209,
    x2: 154.18,
    y2: 107.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B97E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C69637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D2AD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#DDC087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E6D1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F4EBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F9F4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_82_132",
    x1: 195.04,
    y1: 107.209,
    x2: 235.78,
    y2: 107.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrws);
export default __webpack_public_path__ + "static/media/hrws.b4cf84be35aa35190b330ed7b387cd56.svg";
export { ForwardRef as ReactComponent };